import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function DocumentManagerDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_documentManager_cover_redirect"
    />
  );
}
